
































































































































































import Vue from "vue"
import {Company} from "@/model/entity/company/company"
import {Office} from "@/model/entity/office/office"
import {IOfficeService, officeService} from "@/model/service/office/office-service"
import OfficeEditor, {IOfficeEditor} from "@/components/user-administration/OfficeEditor.vue"
import {Employee} from "@/model/entity/employee/employee"

export interface ICompanyOffices extends Data, Vue {
  resetOffices(): void
}

interface LabeledValue {
  label: string
  value: string
}

interface Data {
  page: number
  size: number
  total: number
  officeService: IOfficeService
  offices: Office[]
  officeEmployees: OfficeEmployeesWrapper[]
  isAdd: boolean
  formsValid: boolean
  formats: LabeledValue[]
  charsets: LabeledValue[]
}

interface OfficeEmployeesWrapper {
  office: Office
  employees: Employee[]
}

export default Vue.extend({
  components: {OfficeEditor},
  data(): Data {
    return {
      page: 1,
      size: 12,
      total: 0,
      officeService: officeService,
      offices: [],
      officeEmployees: [],
      isAdd: false,
      formsValid: false,
      formats: [
        {
          label: "PDF A6",
          value: "PDF_A6"
        },
        {
          label: "PDF A4",
          value: "PDF_A4"
        },
        {
          label: "ZPL 203 dpi",
          value: "ZPL_203"
        },
        {
          label: "ZPL 300 dpi",
          value: "ZPL_300"
        }
      ],
      charsets: [
        {
          label: "UTF-8",
          value: "UTF_8"
        },
        {
          label: "ISO-8859-2",
          value: "ISO_8859_2"
        },
        {
          label: "Windows 1250",
          value: "WINDOWS_1250"
        }
      ]
    }
  },
  props: {
    company: {
      type: Object as () => Company,
      required: true
    }
  },
  methods: {
    getFormat(office: Office) {
      const saved = office.reportPageFormat === "ZPL" ? "ZPL_203" : office.reportPageFormat
      return (this.formats.find(f => f.value === saved) || { label: saved }).label
    },
    getCharset(office: Office) {
      return this.charsets.find(charset => charset.value === office.charset)!.label
    },
    validateEmployees() {
      if (this.officeEmployees.length > 0 && this.officeEmployees.length === this.officeEmployees.length) {
        return !this.officeEmployees.find(officeEmployee => officeEmployee.employees.length === 0)
      }
      return false
    },
    startAddOffice() {
      this.isAdd = true
    },
    addOffice() {
      const vm = this
      const newOfficeEditor = vm.$refs.newOfficeEditor as IOfficeEditor
      const newOffice = newOfficeEditor.editedOffice!
      newOffice.company = vm.company

      if (exists(vm.company.id)) {
        vm.simulateLoading()
        officeService
          .create(newOffice)
          .then((result, ...args) => {
            if (!result || !result.data) {
              return
            }
            vm.offices.push(result.data)
            vm.officeEmployees.push({
              office: result.data,
              employees: []
            })
            vm.closeAdd()
          }, (response) => {
            if (response.data && response.data.message) {
              vm.$error(response.data.message)
            } else {
               vm.$error(response)
            }
            vm.endLoad()
          })
          .catch((error) =>  {
            vm.$error(error.message)
          })
      } else {
        vm.offices.push(newOffice)
        vm.officeEmployees.push({
          office: newOffice,
          employees: []
        })
        vm.closeAdd()
        vm.simulateLoading()
      }
    },
    updateOffice(office: Office, index: number) {
      const vm = this
      if (exists(office.id)) {

        if (office.id === vm.$store.getters.loggedUser.office.id) {
          vm.$i18n.locale = office.lang.toLowerCase()
          vm.$store.state.authenticatedEmployee.office = office

        }
        vm.simulateLoading()
        officeService
          .modify(office)
          .then(result => {
            Object.assign(vm.offices[index], result.data)
          }, (response) => {
            if (response.data && response.data.message) {
              vm.$error(response.data.message)
            } else {
               vm.$error(response)
            }
            vm.endLoad()
          })
          .catch(error => vm.$error(error.response.data.message))
      } else {
        vm.simulateLoading()
        Object.assign(vm.offices[index], office)
      }
    },
    deleteOffice(index: number) {
      this.offices.splice(index, 1)
      this.officeEmployees.splice(index, 1)
    },
    simulateLoading() {
      const vm = this
      vm.startLoad()
      setTimeout(() => {
        vm.endLoad()
      }, 700)
    },
    closeAdd() {
      this.isAdd = false
    },
    resetOffices() {
      const vm = this
      if (!!vm.company.id) {
        vm.startLoad()
        vm.officeService
          .getOfficeByCompany(vm.company.id)
          .then(res => {
            vm.offices = res.data
            vm.officeEmployees = vm.offices.map(office => {
              return {
                office: office,
                employees: []
              }
            })

            if (vm.offices.length > 0) {
              let processed = 0
              vm.offices.forEach((office: Office, index: number) => {
                vm.$http.get("/employee/by_office/" + office.id).then(employeeRes => {
                  if (vm.officeEmployees.length) {
                      vm.officeEmployees[index].employees = employeeRes.data
                  } else {
                    vm.endLoad()
                  }

                  processed++
                  if (processed === vm.offices.length) {
                    vm.endLoad()
                  }
                })
              })
            } else {
              vm.endLoad()
            }
          })
          .catch(() => vm.endLoad())
      } else {
        vm.offices = []
        vm.officeEmployees = []
      }
    }
  },
  computed: {
    pagedOffices(): Office[] {
      return this.offices.slice((this.page - 1) * this.size, this.page * this.size)
    }
  },
  watch: {
    "company.id": {
      immediate: true,
      handler() {
        this.resetOffices()
      }
    },
    officeEmployees: {
      immediate: true,
      deep: true,
      handler() {
        const employeesValidation = this.validateEmployees()
        if (this.officeEmployees.length === 0) {
          this.$emit("update:hint", "At least one office required")
        } else if (!employeesValidation) {
          this.$emit("update:hint", "Each office needs at least one employee")
        } else {
          this.$emit("update:hint", "")
        }
        this.$emit("update:valid", employeesValidation)
      }
    }
  }
})
